

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { RegistrationDetails } from 'src/app/model/ngrx/registration-details.model';

export const ADD_REGISTRATION_DETAILS = '[REGSDETAIL] Add';
export const REMOVE_REGISTRATION_DETAILS = '[REGSDETAIL] Remove';

// AddPersonalDetails
export class AddRegistrationDetails implements Action {
    readonly type = ADD_REGISTRATION_DETAILS;

    constructor(public payload: RegistrationDetails) { }
}
// RemovePersonalDetails
export class RemoveRegistrationDetails implements Action {
    readonly type = REMOVE_REGISTRATION_DETAILS;

    constructor(public payload: number) { }
}

export type Actions = AddRegistrationDetails | RemoveRegistrationDetails;
